export default "__VITE_ASSET__CjsnjwFM__"